import { rankingItems } from '@/mocks/home';

const tagColors: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const rankColors = ['text-accent-500', 'text-accent-400', 'text-accent-300'];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热门榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              实时热度排行，最火的瓜都在这里
            </p>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#"
                className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span
                  className={`text-xl md:text-2xl font-bold w-10 text-center shrink-0 ${
                    i < 3 ? rankColors[i] : 'text-foreground-300'
                  }`}
                >
                  {String(item.rank).padStart(2, '0')}
                </span>
                <div className="flex-grow min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground-800 truncate hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </p>
                </div>
                <span
                  className={`text-xs font-medium px-2 py-1 rounded whitespace-nowrap shrink-0 ${tagColors[item.tagColor]}`}
                >
                  {item.tag}
                </span>
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap shrink-0 w-16 text-right">
                  {item.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}